import { render, staticRenderFns } from "./PeriodicList.vue?vue&type=template&id=dda4d09e"
import script from "./PeriodicList.vue?vue&type=script&lang=js"
export * from "./PeriodicList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports